module.exports = __webpack_public_path__ + "static/media/kid24.9fbdd188.png";